/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios, { AxiosInstance } from 'axios';
import { dataConfig } from '../../config/forgotPassword.config';
import { apiConfig } from '@/config/apiConfig';

export interface IForgotPasswordUserMethods extends IPluginMethodMap {
  forgotPassword(args: any): Promise<any>;
}

export interface HeaderProps {
  headerName: string;
  headerValue: string;
}

export interface ForgotPasswordProps {
  email: string;
  apiURL: string;
  headers: HeaderProps;
  storeId: string;
}

export class ForgotPasswordService implements IAgentPlugin {
  readonly methods: IForgotPasswordUserMethods;
  constructor() {
    this.methods = {
      forgotPassword: this.forgotPassword.bind(this),
    };
  }

  async forgotPassword(args: ForgotPasswordProps) {
    console.log(`args in forgotPassword`, args);
    let headers: any = {};
    try {
      const res = await axios.post(
        `${apiConfig?.rest?.url}${dataConfig?.forgotPasswordEP}`,
        {
          email: args?.email,
        },
        {
          headers: {
            ...headers,
          },
        }
      );
      if (res?.data) {
        console.log(`forgotPassword:`, res?.data);
        return {
          ...res?.data,
          email: args?.email,
        };
      }
    } catch (err: any) {
      // return err?.response?.data;
      console.log(`forgot password error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
